<template>
  <div class="exhibition_wrap" v-if="hidden">
    <div class="news_tit">Exhibition Preview</div>

    <div class="carousel-bg">
      <div class="slider-hover-wrapper"
           ref="wrapRef"
           @mouseenter="handleMouseEnter"
           @mouseleave="handleMouseLeave"
           @mousedown="handleMouseDown"
           @mousemove="handleMouseMove"
           @mouseup="handleMouseUp">
        <button class="arrow-btn left" v-show="showBtn && list.length > 1" @click="prev">‹</button>

        <div class="slider-section">
          <div class="slider-container"
               @touchstart="touchStart"
               @touchmove="touchMove"
               @touchend="touchEnd">
            <div class="slider-track"
                 :style="{
                   transform: `translateX(${translateX}px)`,
                   transition: isDrag ? 'none' : 'transform 0.5s ease'
                 }">
              <div class="exhibition-card" v-for="item in list" :key="item.sortKey">
                <div class="card-img" v-if="item.image">
                  <img :src="item.image" alt="exhibition"/>
                </div>
                <div class="card-info">
                  <h2 class="card-title" v-if="item.title">{{ item.title }}</h2>
                  <p class="card-time" v-if="item.time">
                    <img src="@/assets/calendar.png" class="time-icon" alt="" />
                    {{ item.time }}
                  </p>
                  <p class="card-desc" v-if="item.desc">{{ item.desc }}</p>
                  <button class="contact-btn" @click="goToPage">Contact Us</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button class="arrow-btn right" v-show="showBtn && list.length > 1" @click="next">›</button>
      </div>
    </div>
  </div>
</template>

<script>
import {leftLikeDict} from '@/api/system'
import {findDictHidden} from '../../utils';
import ScrollReveal from 'scrollreveal'

const DICT_KEY = 'exhibition'

export default {
  data() {
    return {
      hidden: true,
      list: [],
      currentIndex: 0,
      showBtn: false,
      autoPlay: null,
      isMobile: false,
      isDrag: false,
      startX: 0,
      translateX: 0,
      cardWidth: 0
    }
  },
  methods: {
    goToPage() {
      this.$router.push('/fivenav/2')
    },

    handleMouseEnter() {
      this.showBtn = true
    },
    handleMouseLeave() {
      // 鼠标移出区域，强制结束拖拽
      this.isDrag = false
      this.showBtn = false
    },

    // 左键按下：开启拖拽
    handleMouseDown(e) {
      if (this.list.length <= 1) return
      // 仅响应鼠标左键
      if (e.button !== 0) return
      this.isDrag = true
      this.startX = e.clientX
    },
    // 鼠标移动：仅拖拽状态生效
    handleMouseMove(e) {
      if (!this.isDrag) return
      const diff = e.clientX - this.startX
      this.translateX = -this.currentIndex * this.cardWidth + diff
    },
    // 鼠标松开：结束拖拽并判定切换
    handleMouseUp() {
      if (!this.isDrag) return
      this.isDrag = false
      const diff = this.translateX + this.currentIndex * this.cardWidth
      if (diff > this.cardWidth / 4) {
        this.currentIndex = this.currentIndex - 1 < 0 ? 0 : this.currentIndex - 1
      } else if (diff < -this.cardWidth / 4) {
        this.currentIndex = this.currentIndex + 1 >= this.list.length
            ? this.list.length - 1
            : this.currentIndex + 1
      }
      this.translateX = -this.currentIndex * this.cardWidth
    },

    // 左按钮切换（带动画，与拖拽无关）
    prev() {
      if (this.list.length <= 1) return
      this.currentIndex = this.currentIndex - 1 < 0
          ? this.list.length - 1
          : this.currentIndex - 1
      this.translateX = -this.currentIndex * this.cardWidth
    },
    // 右按钮切换（带动画，与拖拽无关）
    next() {
      if (this.list.length <= 1) return
      this.currentIndex = this.currentIndex + 1 >= this.list.length
          ? 0
          : this.currentIndex + 1
      this.translateX = -this.currentIndex * this.cardWidth
    },

    async loadExhibitionData() {
      try {
        const res = await leftLikeDict(DICT_KEY)
        let rootData = []

        if (res && Array.isArray(res.data)) {
          rootData = res.data
        } else if (res && res.data && Array.isArray(res.data.data)) {
          rootData = res.data.data
        }

        this.hidden = findDictHidden(DICT_KEY, rootData)

        if (!Array.isArray(rootData) || rootData.length === 0) {
          console.log("未获取到展会字典数据")
          return
        }

        let titleParent = null
        for (let i = 0; i < rootData.length; i++) {
          if (rootData[i].dictKey === 'exhibitionTitle') {
            titleParent = rootData[i]
            break
          }
        }
        if (!titleParent || !Array.isArray(titleParent.children)) {
          console.log("未找到展会子项列表")
          return
        }

        const childrenList = titleParent.children
        const dataMap = new Map()

        for (let j = 0; j < childrenList.length; j++) {
          const child = childrenList[j]
          const reg = /^exhibitionContent(\d+)(Title|Time|SubTitle1|Image)$/
          const match = child.dictKey.match(reg)
          if (!match) continue

          const num = match[1]
          const fieldType = match[2]

          if (!dataMap.has(num)) {
            dataMap.set(num, {
              sortKey: num,
              title: '',
              time: '',
              desc: '',
              image: ''
            })
          }

          const currItem = dataMap.get(num)
          switch (fieldType) {
            case 'Title':
              currItem.title = child.dictValue || ''
              break
            case 'Time':
              currItem.time = child.dictValue || ''
              break
            case 'SubTitle1':
              currItem.desc = child.dictValue || ''
              break
            case 'Image':
              currItem.image = child.dictValue || ''
              break
          }
        }

        let resultList = Array.from(dataMap.values())
            .sort((a, b) => Number(a.sortKey) - Number(b.sortKey))

        this.list = resultList.filter(item => item.title || item.image)

        this.$nextTick(() => {
          this.cardWidth = this.$refs.wrapRef.clientWidth
          this.translateX = -this.currentIndex * this.cardWidth

          this.updateLayout()
          ScrollReveal().reveal(['.news_tit', '.exhibition-card'], {
            distance: 10,
            duration: 800,
            interval: 100,
            origin: 'bottom'
          })
          this.restartAutoPlay()
        })
      } catch (err) {
        console.error('加载展会数据异常：', err)
      }
    },

    updateLayout() {
      this.isMobile = window.innerWidth < 769
      if (this.$refs.wrapRef) {
        this.cardWidth = this.$refs.wrapRef.clientWidth
        this.translateX = -this.currentIndex * this.cardWidth
      }
    },

    startAuto() {
      if (this.list.length <= 1) return
      this.autoPlay = setInterval(() => {
        this.next()
      }, 4000)
    },

    restartAutoPlay() {
      clearInterval(this.autoPlay)
      this.startAuto()
    },

    // 移动端触摸
    touchStart(e) {
      if (this.list.length <= 1) return
      this.isDrag = true
      this.startX = e.touches[0].clientX
    },
    touchMove(e) {
      if (!this.isDrag) return
      const diff = e.touches[0].clientX - this.startX
      this.translateX = -this.currentIndex * this.cardWidth + diff
    },
    touchEnd() {
      this.handleMouseUp()
    }
  },
  mounted() {
    this.loadExhibitionData()
    window.addEventListener('resize', this.updateLayout)
  },
  beforeDestroy() {
    clearInterval(this.autoPlay)
    window.removeEventListener('resize', this.updateLayout)
  }
}
</script>

<style lang="scss" scoped>
.exhibition_wrap {
  width: 100%;
  margin: 50px 0;
  text-align: center;

  .news_tit {
    font-size: 40px;
    font-weight: bold;
    color: #203040;
    font-family: 'Roboto_Bold', sans-serif;
    margin-bottom: 40px;
    position: relative;

    @media (max-width: 768px){
      font-size: 28px;
      font-weight: bold;
      color: #203040;
      font-family: 'Roboto_Bold', sans-serif;
    }

    &::after {
      content: '';
      display: block;
      width: 80px;
      height: 3px;
      background: #880f53;
      margin: 10px auto 0;

      @media (max-width: 768px){
        width: 60px;
        height: 3px;
      }
    }
  }
}

.carousel-bg {
  padding: 60px 0;
  margin: 20px 0;
}

.slider-hover-wrapper {
  position: relative;
  width: 80%;
  margin: 0 auto;
  box-sizing: border-box;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}

.slider-section {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.slider-container {
  width: 100%;
  overflow: hidden;
}

.slider-track {
  display: flex;
  width: 100%;
}

.exhibition-card {
  width: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  background: #f6f6f6;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  overflow: hidden;

  .card-img {
    width: 45%;
    height: 420px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .card-info {
    width: 55%;
    padding: 30px 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;

    .card-title {
      font-size: 32px;
      font-weight: bold;
      color: #000;
      margin: 0 0 12px;
      line-height: 1.3;
      font-family: "Roboto", sans-serif;
    }

    .card-time {
      font-size: 20px;
      color: #333;
      margin: 0 0 20px;
      display: flex;
      align-items: center;
      font-family: "Roboto", sans-serif;
      gap:8px;

      .time-icon {
        width:20px;
        height:auto;
      }

      @media (max-width:768px){
        justify-content: center;
        .time-icon{
          width:16px;
        }
      }
    }

    .card-desc {
      font-size: 18px;
      color: #666;
      line-height: 1.7;
      margin: 0 0 30px;
      font-family: "Roboto", sans-serif;
    }

    .contact-btn {
      width: fit-content;
      padding: 12px 28px;
      border: 1px solid #880f53;
      background: #fff;
      color: #880f53;
      font-size: 16px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-family: "Roboto", sans-serif;
      font-weight: bold;
      &:hover {
        background: #880f53;
        color: #fff;
      }
    }
  }
}

.arrow-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 46px;
  height: 64px;
  background: #880f53;
  color: #fff;
  border: none;
  font-size: 20px;
  cursor: pointer;
  z-index: 9999;
}
.arrow-btn.left {
  left: -50px;
}
.arrow-btn.right {
  right: -50px;
}
.arrow-btn:hover {
  background: #6f063f;
}

@media (max-width: 768px) {
  .carousel-bg {
    padding: 40px 0;
  }
  .slider-hover-wrapper {
    width: 92%;
  }
  .arrow-btn {
    display: none !important;
  }
  .exhibition-card {
    flex-direction: column;

    .card-img {
      width: 100%;
      height: 260px;
    }

    .card-info {
      width: 100%;
      padding: 20px;
      text-align: center;

      .card-title {
        font-size: 22px;
      }

      .card-time {
        font-size: 16px;
      }

      .card-desc {
        font-size: 14px;
      }

      /* 完整层级，放大按钮 */
      .contact-btn {
        margin: 0 auto;
        padding: 10px 30px;
        font-size: 14px;
      }
    }
  }
}
</style>